// TODO: Remove old endpoints — deprecation date: October 27, 2026
import React, { useEffect, useState } from "react";
import thankyouSVG from "./../../assets/img/svg/circle-check-solid.svg";
import { useDispatch } from "react-redux";
import { recordUserResponseOnVacateEmailAction } from "../../redux/actions/noticeToVacate";
import { useParams } from "react-router-dom";
import FullPageLayout from "../../layout/FullPageLayout";
import { useTranslation } from "react-i18next";

const formatDateTime = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleString("en-US", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const cardStyle = {
  maxWidth: 720,
  width: "100%",
  borderRadius: 16,
  border: "none",
  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
};

const headingStyle = {
  fontWeight: 600,
  color: "#1f2d3d",
  letterSpacing: "-0.01em",
};

const bodyTextStyle = {
  maxWidth: 560,
  margin: "0 auto",
  lineHeight: 1.65,
  fontSize: "1.0625rem",
};

const RecordUserResponseOnVacateEmail = () => {
  const dispatch = useDispatch();
  const { recordId, option } = useParams();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [brokenLink, setIsBrokenLink] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    setLoading(true);
    dispatch(
      recordUserResponseOnVacateEmailAction(
        recordId,
        option,
        (data) => {
          setLoading(false);
          if (!data) {
            setIsBrokenLink(true);
            return;
          }
          setResult(data);
        },
        () => {
          setLoading(false);
          setIsBrokenLink(true);
        }
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderLoading = () => (
    <>
      <span
        className="spinner-grow text-primary mb-4"
        style={{ width: 56, height: 56 }}
      />
      <h4 className="mb-2" style={headingStyle}>
        {t("leaseAction.processing")}
      </h4>
      <p className="text-muted mb-0">
        This process may take up to a full minute.
      </p>
    </>
  );

  const renderBrokenLink = () => (
    <>
      <div
        style={{
          width: 96,
          height: 96,
          borderRadius: "50%",
          background: "#FEE2E2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 56,
          fontWeight: 600,
          color: "#DC2626",
          margin: "0 auto 1.75rem",
          lineHeight: 1,
        }}
      >
        !
      </div>
      <h3 className="mb-3" style={headingStyle}>
        {t("modal.notice.no_records_found")}
      </h3>
      <p className="text-muted mb-2" style={bodyTextStyle}>
        {t("modal.notice.this_could_happen_if")}
      </p>
      <ul
        className="text-muted text-start mx-auto mb-0"
        style={{ maxWidth: 380 }}
      >
        <li>{t("modal.notice.application_has_finalise")}</li>
        <li>{t("modal.notice.the_link_is_broken_or_expired")}</li>
      </ul>
    </>
  );

  const renderRecordedFresh = () => {
    const heading =
      option === "1"
        ? t("leaseAction.noticeReceived")
        : t("leaseAction.thankYou");
    const body =
      option === "1"
        ? t("leaseAction.legacyVacateRecorded")
        : t("leaseAction.thankYouRenew");
    return (
      <>
        <img
          src={thankyouSVG}
          alt=""
          width={96}
          height={96}
          style={{ marginBottom: "1.75rem" }}
        />
        <h2 className="mb-3" style={headingStyle}>
          {heading}
        </h2>
        <p className="text-muted mb-0" style={bodyTextStyle}>
          {body}
        </p>
      </>
    );
  };

  const renderAlreadyChose = () => {
    const ec = result.existingChoice;
    const choiceText = ec?.decision || result.decision;
    const tsDisplay = formatDateTime(ec?.decisionTs);
    const leadIn = ec?.decisionEmail
      ? `${ec.decisionEmail} ${t("leaseAction.alreadyChose")}`
      : t("leaseAction.tenantAlreadyChose");
    return (
      <>
        <img
          src={thankyouSVG}
          alt=""
          width={80}
          height={80}
          style={{ marginBottom: "1.5rem", opacity: 0.9 }}
        />
        <h2 className="mb-3" style={headingStyle}>
          {t("leaseAction.alreadyRecorded")}
        </h2>
        <p className="text-muted mb-0" style={bodyTextStyle}>
          {leadIn}{" "}
          <strong style={{ color: "#1f2d3d" }}>{choiceText}</strong>{" "}
          {t("leaseAction.on")} {tsDisplay}.
        </p>
      </>
    );
  };

  const renderBody = () => {
    if (loading) return renderLoading();
    if (brokenLink || !result) return renderBrokenLink();
    if (result.recorded === false) return renderAlreadyChose();
    return renderRecordedFresh();
  };

  return (
    <FullPageLayout>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "75vh",
          padding: "2rem 1rem",
        }}
      >
        <div className="card" style={cardStyle}>
          <div
            className="card-body text-center"
            style={{ padding: "3.5rem 3rem" }}
          >
            {renderBody()}
          </div>
        </div>
      </div>
    </FullPageLayout>
  );
};

export default RecordUserResponseOnVacateEmail;
